(function ($) {

    /**
     * Repair status
     */
    $('select.color_class').on('change', function () {
        $(this).attr('class', 'form-control color_class ' + $(this).val());
    });

    $(document).on('click', '#no_company', function () {
        $('#company_id').val(0).trigger('change');
    });

    /**
     * Submit Form on Brand Select (Product Batch Edit)
     */
    $(document).on('change', 'select#selectbrand', function () {
        $(this).closest('form').submit();
    });

    /**
     * Open first tab with validation messages
     */
    if ($('.tab-pane .has-error').length) {
        var firstError = $('.tab-pane .has-error').first();
        var tabContent = $(firstError).closest('.tab-pane');
        var id         = tabContent.attr('id');
        $('ul.nav-tabs li').removeClass('active');
        $('.nav-tabs a[href="#' + id + '"]').tab('show');
    }

    /**
     * Sync top and bottom clicked statues tabs on Repair tables
     */
    $(document).on('click', 'ul.nav-tabs.synctabs li', function () {
        $('ul.nav-tabs li').removeClass('active');
        $('ul.nav-tabs li.' + $(this).attr('class').replace('active', '')).addClass('active');
    });

    /**
     * Open message tab on button click
     */
    $(document).on('click', '#messagetabbutton', function () {
        $('.nav-tabs a[href="#messages-tab"]').tab('show');
    });

    /**
     * Save message on button click on repair main tab
     */
    $(document).on('click', '#messagebutton', function () {
        var elem = $(this);

        $.ajax({
            url: elem.attr('href'),
            type: 'POST',
            data: {
                _method: 'post',
                message: $('#sendmessage').val(),
                title: 'Opmerking medewerker',
                recipient_user_id: $('#employee_id').val()
            },
            success: function (data) {
                swal({
                    title: "Bericht Opgeslagen!",
                    type: "success",
                    timer: 2000,
                    showConfirmButton: false
                });
            },
            error: function () {
                swal("Fout!", 'Er gings iets fout bij opslaan, "error"');
            }
        });
    });

    /**
     * Select tab and scroll to form on repair message form when errors appear...
     */
    if ($('#messages-tab div.form-group.has-error').length) {
        $('.nav.nav-tabs li').removeClass('active');
        $('.nav.nav-tabs li.tab2').addClass('active');
        $('#repair-tab').removeClass('active');
        $('#messages-tab').addClass('active');
        $('html, body').delay(1000).animate({scrollTop: $('.main-footer').position().top});
    }

    $(document).on('change', '#brand_id', function () {
        getDevices();
        getReturnInfo();
    });

    $(document).on('change', '#device_id', function () {
        if ($(this).hasClass('motherboard')) {
            getProducts('motherboard');
        } else if (!$('#product-tab').length) { // except product creation
            getComplaintDescription();
        }
    });

    if (!$('#product_id').val()) {
        $('#product_id').empty().prop('disabled', true);
    }

    /**
     * Find price estimation on device select
     */
    $(document).on('change', '#complaintdescription_id', function () {
        getPriceEstimation();
    });

    /**
     * Toggle Test Report Type Repair Test rapport form
     */
    $(document).on('change', 'select[name="test_report_type"]', function () {
        toggleReportType();
    });

    /**
     * Toggle messaged field by repair status update
     */
    $(document).on('change', 'input[name="send_email"]', function () {
        toggleSendStatusMessage();
    });

    /**
     * Postcode address search
     */
    $(document).on('keypress keyup blur', 'input[name="postcode"], input[name="house_number"]', function () {
        var form = $(this).closest('form');
        postcodeSearch(
            $(form).find('input[name="postcode"]').val(),
            $(form).find('input[name="house_number"]').val(),
            $(form).find('input[name="street"]'),
            $(form).find('input[name="place"]')
        );
    });

    var select2Data = null;

    /**
     * Customer search
     */
    $('select.ajaxselect').each(function () {
        var url  = $(this).attr('data-source');
        var elem = $(this);

        elem.select2({
            ajax: {
                url: function (params) {
                    params.page = params.page || 1;
                    if (params.term !== "") {
                        return url + "?q=" + params.term + "&page=" + params.page;
                    }
                },
                dataType: 'json',
                delay: 250,
                processResults: function (data, params) {
                    params.page = params.page || 1;
                    select2Data = data.data;
                    return {
                        results: $.map(data.data, function (obj) {
                            return {id: obj.id, text: (obj.label || obj.name)};
                        }),
                        pagination: {
                            more: (data.current_page < data.last_page)
                        }
                    };
                },
                cache: true
            },
            escapeMarkup: function (markup) {
                return markup;
            },
            minimumInputLength: 1
        });
    });

    // todo below 4 methods are pretty duplicate....

    /**
     * Show address when a customer is selected with a new repair.
     */
    $('#customer_id').on("select2:select", function (e) {
        var id     = $(this).val();
        var result = $.grep(select2Data, function (e) {
            return e.id === id;
        });
        $('input[name="customer_data"]').val(JSON.stringify(result[0]));
        $('#repaircustomer').html(formatCustomer(result[0]));
    });

    /**
     * On Customer Modal close, remove existing customer select and add a hidden customer_id field
     */
    $('#customermodal').on("select_modal_item", function (e, data) {
        $('#customer_id').append($('<option>', {value: data.id}).text(data.name).attr('selected', 'selected'));
        $('#customer_id').select2('data', {id: data.id, text: data.name});
        $('#repaircustomer').html(formatCustomer(data));
        $('input[name="customer_data"]').val(JSON.stringify(data));
    });

    /**
     * Show address when a company is selected with a new company.
     */
    $('#company_id').on("select2:select", function (e) {
        var id     = $(this).val();
        var result = $.grep(select2Data, function (e) {
            return e.id === id;
        });
        $('#customercompany').html(formatCompany(result[0]));
    });

    /**
     * On Company Modal close, remove existing company select and add a hidden copany_id field
     */
    $('#companymodal').on("select_modal_item", function (e, data) {

        $('#company_id').append($('<option>', {value: data.id}).text(data.label).attr('selected', 'selected'));
        $('#company_id').select2('data', {id: data.id, text: data.label});

        $('#repaircompany').html(formatCompany(data));
        $('input[name="company_data"]').val(JSON.stringify(data));

        if (data.copy_values) {
            $.each(data, function (key, value) {
                if (key !== 'id') {
                    $('input[name="' + key + '"]').val(value);
                }
            });
        }

    });

    /**
     * Update example window of message editors
     */
    if ($('#status_email_preview').length) {
        $('.summernote').on('summernote.change', function (we, contents, $editable) {
            updateEmailPreview(contents, $('#status_email_preview'));
        });
    }

    /**
     * Select variable on click
     */
    $(document).on("click", "th.variable", function () {
        $(this).selectText();
    });

}(jQuery));

function updateEmailPreview(sourceContent, targetDiv) {
    $.each($('.emailvariables').find('tr'), function () {
        var re        = new RegExp($(this).find('.variable').text(), "g");
        sourceContent = sourceContent.replace(re, $(this).find('.example').text());
    });
    targetDiv.html(sourceContent);
}

function postcodeSearch(zip, nr, streetField, placeField) {
    if (zip.length >= 6 && nr.length > 0) {
        $.get('/api/postcode?zip=' + zip + '&nr=' + nr, function (address) {
            if (address.street) streetField.val(address.street);
            if (address.city) placeField.val(address.city);
        });
    }
}

function getDevices() {
    var brand_id = $('#brand_id').val();
    var type     = $('input[name="type"]').val();

    if (brand_id) {
        $('#device_id').empty().prop('disabled', false).append("<option value='' disabled selected>Selecteer uw device</option>");

        $.getJSON('/api/device', {brand_id: brand_id, type: type}, function (data) {
            if (data.data.length) {
                $.each(data.data, function (key, item) {
                    $('#device_id').attr('required', 'required').append("<option value='" + item.id + "'>" + item.title + "</option>");
                });
                $('#devicewrapper').show();
            } else {
                $('#device_id').removeAttr('required');
                $('#devicewrapper').hide();
            }
        });

    }
}

function getReturnInfo() {
    var brand_id = $('#brand_id').val();
    var type     = $('input[name="type"]').val();

    $('#return_info_file').hide();
    $('#info_text_panel').hide();

    if (brand_id && type === 'mobile') {
        $('#return_info_file a').attr('href', '');

        $.getJSON('/api/brands/' + brand_id, {type: type}, function (data) {
            if (data.data.retour_info_file) {
                $('#return_info_file a').attr('href', data.data.retour_info_file);
                $('#return_info_file').show();
            }
            if (data.data.info_text) {
                $('#info_text_panel .panel-body').html(data.data.info_text);
                $('#info_text_panel').show();
            }
        });
    }
}

function getProducts(a) {
    var device_id = $('#device_id').val();
    var type      = typeof a !== 'undefined' ? a : 'mobile';

    if (device_id) {
        $('#product_id')
            .empty()
            .prop('disabled', false)
            .append("<option value='' disabled selected> </option>");

        $.getJSON('/api/product', {device_id: device_id, type: type}, function (data) {
            $.each(data.data, function (key, item) {
                $('#product_id').append("<option value='" + item.id + "'>" + item.title + "</option>");
            });
        });
    }
}

function getComplaintDescription() {
    var device_id = $('#device_id').val();

    if (device_id) {
        $('#complaintdescription_id')
            .empty()
            .prop('disabled', false)
            .append("<option value='' disabled selected> </option>");

        $.getJSON('/api/complaintdescriptions', {device_id: device_id}, function (data) {
            $.each(data.data, function (key, item) {
                $('#complaintdescription_id').append("<option value='" + item.id + "'>" + item.name + "</option>");
            });
        });
    }
}

function getPriceEstimation() {
    var complaint_id = $('#complaintdescription_id').val();
    var device_id    = $('#device_id').val();

    if (complaint_id && device_id) {
        $('#priceestimation').hide();
        $('#priceestimation input').val('');
        $.get('/api/priceestimation/' + complaint_id + '/' + device_id, function (price) {
            $('#priceestimation input').val(price);
            price ? $('#priceestimation').show() : $('#priceestimation').hide();
        });
    }
}

function toggleReportType() {
    var type = $('select[name="test_report_type"]').val();
    if (type === 'mobile') {
        $('#testrapport').show();
        $('#computertestrapport').hide();
    } else if (type === 'computer') {
        $('#computertestrapport').show();
        $('#testrapport').hide();
    }
}

function toggleSendStatusMessage() {
    var check = $('input[name="send_email"]:checked').val();
    if (check) {
        $('div.togglemessage').show().attr('required', 'required');
    } else {
        $('div.togglemessage').hide().removeAttr('required');
    }
}

function formatCustomer(data) {
    return '<table class="table nopadding"><tbody>' +
        '<tr><td><strong>Email :</strong></td><td>' + data.email + '</td><td rowspan="3" align="right">' +
        '<button type="button" class="btn" data-toggle="modal" data-target="#customermodal" data-field="customer_data"><i class="fa fa-fw fa-edit"></i></button>' +
        '</td></tr>' +
        '<tr><td><strong>Telefoon :</strong></td><td>' + data.phone_number + '</td></tr>' +
        '<tr><td><strong>Adres :</strong></td><td>' + data.full_address + '</td></tr>' +
        '</tbody></table>';
}

function formatCompany(data) {
    return '<br><strong>Naam :</strong> ' + data.name + '<br>' +
        '<strong>Adres :</strong> ' + data.full_address;
}

$(document).ready(function ($) {

    //getDevices(); // breaks admin selection....

    getPriceEstimation();

    toggleReportType();

    toggleSendStatusMessage();

    if ($('input[name="customer_data"]').length) {
        var text = $('input[name="customer_data"]').val();
        if (text) {
            $('#repaircustomer').html(formatCustomer(JSON.parse(text)));
        }
    }

    if ($('input[name="company_data"]').length) {
        var text = $('input[name="company_data"]').val();
        if (text) {
            $('#customercompany').html(formatCompany(JSON.parse(text)));
        }
    }
});

jQuery.fn.selectText = function () {
    var doc     = document;
    var element = this[0];
    var range     = false;
    if (doc.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
    } else if (window.getSelection) {
        var selection = window.getSelection();
        range         = document.createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
    }
};
